import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export const NOTIFICATION_PAGE_LIMIT = 10;

export interface NotificationResponse {
  userNotifications: Notifications[];
  nextCursor: string | null;
}

export interface GetNotificationsParams {
  cursor?: string;
  limit?: number;
  includeRead?: boolean;
}

export interface Notifications {
  id: string;
  title: string;
  body: string;
  link?: string | null;
  data?: Record<string, unknown>;
  userId: string;
  isDeleted: boolean;
  isRead: boolean;
  readAt?: string | null;
  notificationEventId?: string;
  createdAt: string;
  updatedAt?: string;
  notification_event_id?: string;
  notificationEvent?: {
    id: string;
    notificationType: string;
    loanId: string;
    contextData: Record<string, unknown>;
    status: string;
    entityId: string;
    templateId: string;
    loan_id: string;
    template_id: string;
    entityType: string;
    errorDetails: string | null;
    scheduledAt: string | null;
    processedAt: string;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    template?: {
      id: string;
      sharedTemplateId: string | null;
      channel: string;
      name: string;
      variables: Record<string, unknown>;
      version: number;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
      notificationType: string;
      subjectTemplate: string;
      htmlBodyTemplate: string;
      textBodyTemplate: string;
      isDeleted: boolean;
    };
  };
  // Fallbacks for older data / UI logic
  type?: string;
  entityType?: string;
}

const _mockData: Notifications[] = [
  {
    id: 'sojsnitlkm4mi2if5ma609ws',
    userId: 'cmie62v7k046poxb6z2wrmz8e',
    title:
      'Alcantar, Maria Del - Verbal Verification Of Employment Baker Boy Dern.pdf (Started)',
    body: 'Income - Verbal VOE: Verbal Verification Of Employment Baker Boy Dern.pdf uploaded for Maria Del Alcantar on loan MOS-Loan-Mail_3 (Started)',
    link: null,
    data: {
      loanId: '389936ad-2878-4cea-8b79-0855dcc08ae6',
      loanNumber: 'MOS-Loan-Mail_3',
      uploadTime: 'March 6, 2026 at 8:48 AM',
      uploadedBy: 'System',
      documentUrl: 'http://localhost:3000/loan/s9f3i5nxg88pinsgw8gehem6/panel',
      efolderName: 'Income - Verbal VOE',
      borrowerName: 'Maria Del Alcantar',
      documentName: 'Verbal Verification Of Employment Baker Boy Dern.pdf',
      documentType: 'Verbal Verification Of Employment',
      idempotencyKey:
        's9f3i5nxg88pinsgw8gehem6-yorh4h3p054ghq2lbm33liqy:IN_APP',
      borrowerLastName: 'Alcantar',
      currentMilestone: 'Started',
      borrowerFirstName: 'Maria Del',
    },
    isRead: false,
    readAt: null,
    notificationEventId: 'iowiqxv94w4adwpo8c7d208d',
    isDeleted: false,
    createdAt: '2026-03-06T13:48:38.451Z',
    updatedAt: '2026-03-06T13:48:38.451Z',
    notification_event_id: 'iowiqxv94w4adwpo8c7d208d',
    notificationEvent: {
      id: 'iowiqxv94w4adwpo8c7d208d',
      templateId: 'ij6r2s6iq2rsqxbb11jbtezm',
      loanId: 's9f3i5nxg88pinsgw8gehem6',
      notificationType: 'DOCUMENT_UPLOADED',
      entityType: 'LOAN',
      entityId: '389936ad-2878-4cea-8b79-0855dcc08ae6',
      contextData: {
        loanId: '389936ad-2878-4cea-8b79-0855dcc08ae6',
        loanNumber: 'MOS-Loan-Mail_3',
        uploadTime: 'March 6, 2026 at 8:48 AM',
        uploadedBy: 'System',
        documentUrl:
          'http://localhost:3000/loan/s9f3i5nxg88pinsgw8gehem6/panel',
        efolderName: 'Income - Verbal VOE',
        borrowerName: 'Maria Del Alcantar',
        documentName: 'Verbal Verification Of Employment Baker Boy Dern.pdf',
        documentType: 'Verbal Verification Of Employment',
        idempotencyKey:
          's9f3i5nxg88pinsgw8gehem6-yorh4h3p054ghq2lbm33liqy:IN_APP',
        borrowerLastName: 'Alcantar',
        currentMilestone: 'Started',
        borrowerFirstName: 'Maria Del',
      },
      status: 'COMPLETED',
      errorDetails: null,
      scheduledAt: null,
      processedAt: '2026-03-06T13:48:38.334Z',
      isDeleted: false,
      createdAt: '2026-03-06T13:48:38.116Z',
      updatedAt: '2026-03-06T13:48:38.605Z',
      loan_id: 's9f3i5nxg88pinsgw8gehem6',
      template_id: 'ij6r2s6iq2rsqxbb11jbtezm',
      template: {
        id: 'ij6r2s6iq2rsqxbb11jbtezm',
        sharedTemplateId: null,
        name: 'Document Uploaded In-App',
        notificationType: 'DOCUMENT_UPLOADED',
        channel: 'IN_APP',
        subjectTemplate:
          '{{borrowerLastName}}, {{borrowerFirstName}} - {{documentName}}{{#if currentMilestone}} ({{currentMilestone}}){{/if}}',
        htmlBodyTemplate:
          '\n<div style="font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, sans-serif;">\n  <p style="margin: 0 0 4px; font-size: 14px; color: #1a1a1a;">\n    <strong>{{efolderName}}</strong>: {{documentName}}\n  </p>\n  <p style="margin: 0; font-size: 13px; color: #6b7280;">\n    {{borrowerName}} · Loan {{loanNumber}}{{#if currentMilestone}} · {{currentMilestone}}{{/if}} · {{uploadTime}}\n  </p>\n</div>\n      ',
        textBodyTemplate:
          '{{efolderName}}: {{documentName}} uploaded{{#if borrowerName}} for {{borrowerName}}{{/if}} on loan {{loanNumber}}{{#if currentMilestone}} ({{currentMilestone}}){{/if}}',
        variables: {
          loanNumber: {
            type: 'string',
            description: 'Human-readable loan number',
          },
          uploadTime: {
            type: 'string',
            description:
              'Time when the document was uploaded (human-readable format, e.g., Jan 13 at 2:30 PM)',
          },
          uploadedBy: {
            type: 'string',
            description: 'Name of the user who uploaded the document',
          },
          efolderName: {
            type: 'string',
            description: 'Name of the eFolder where the document was uploaded',
          },
          borrowerName: {
            type: 'string',
            description: 'Full name of the borrower (first + last name)',
          },
          documentName: {
            type: 'string',
            description: 'Name of the document',
          },
          documentType: {
            type: 'string',
            description: 'Type of the document',
          },
          recipientName: {
            type: 'string',
            description: 'Name of the recipient',
          },
          borrowerLastName: {
            type: 'string',
            description: 'Last name of the borrower',
          },
          currentMilestone: {
            type: 'string',
            description: 'Current milestone of the loan (optional)',
          },
          borrowerFirstName: {
            type: 'string',
            description: 'First name of the borrower',
          },
        },
        isActive: true,
        version: 6,
        isDeleted: false,
        createdAt: '2025-10-22T15:55:17.186Z',
        updatedAt: '2026-02-25T22:28:01.774Z',
      },
    },
  },
];

const getNotifications = async (
  params: GetNotificationsParams = {},
): Promise<NotificationResponse> => {
  const {
    cursor,
    limit = NOTIFICATION_PAGE_LIMIT,
    includeRead = true,
  } = params;

  if (isMockServices()) {
    const mockList = await mock(_mockData);
    return {
      userNotifications: mockList,
      nextCursor: null,
    };
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const searchParams = new URLSearchParams({
    includeRead: String(includeRead),
    limit: String(limit),
  });
  if (cursor) searchParams.set('cursor', cursor);

  const response = await authTokenHttp<NotificationResponse>(
    `/users/me/notifications?${searchParams.toString()}`,
    { method: 'GET' },
  );

  if (response.data)
    return {
      userNotifications: response.data.userNotifications ?? [],
      nextCursor: response.data.nextCursor ?? null,
    };

  throw new Error('Failed to fetch notifications');
};

export default getNotifications;
